export default __webpack_public_path__ + "static/media/seva-and-darshanam.f94fc917.svg";